import type { PublicApiKey } from '@/apilib';
import type { createTpaApi } from './tpaWrapper';

export const TpaApiKey: PublicApiKey<typeof createTpaApi> = {
  name: 'TpaApi',
  public: true,
};
